import React from 'react';
import { ChevronLeft, Send } from 'lucide-react';
import { formatDate } from './utils';

export const ThreadDetailView = ({ 
  thread, 
  onBack, 
  replyContent,
  setReplyContent,
  replyAnonymous,
  setReplyAnonymous,
  onSubmitReply,
  submitting
}) => {
  return (
    <div className="min-h-screen pb-24" style={{ background: '#FBF9F6' }}>
      <div className="max-w-2xl mx-auto px-4 py-6">
        {/* Header */}
        <button
          onClick={onBack}
          className="flex items-center gap-2 mb-6 transition-opacity hover:opacity-70"
          style={{ color: '#C9A84C', fontFamily: 'Jost, sans-serif' }}
          data-testid="back-to-threads"
        >
          <ChevronLeft className="w-5 h-5" />
          Back to threads
        </button>

        {/* Thread */}
        <div 
          className="p-6 rounded-2xl mb-6"
          style={{ background: '#F9F4F0', border: '1px solid #F3EEE8' }}
        >
          <h2 
            className="text-xl font-medium mb-2"
            style={{ color: '#1A1A2E', fontFamily: 'Jost, sans-serif' }}
          >
            {thread.title}
          </h2>
          <p 
            className="text-sm mb-4"
            style={{ color: '#6B6878', fontFamily: 'Jost, sans-serif' }}
          >
            {thread.author_name} · {formatDate(thread.created_at)}
          </p>
          <p 
            className="leading-relaxed"
            style={{ color: '#2E2E42', fontFamily: 'Jost, sans-serif' }}
          >
            {thread.content}
          </p>
        </div>

        {/* Replies */}
        <div className="mb-6">
          <h3 
            className="text-sm font-medium mb-4"
            style={{ color: '#6B6878', fontFamily: 'Jost, sans-serif' }}
          >
            {thread.replies?.length || 0} Replies
          </h3>
          
          {thread.replies?.map((reply) => (
            <div 
              key={reply.id}
              className="p-4 rounded-xl mb-3"
              style={{ background: '#FAF7F3', border: '1px solid #F7F1EE' }}
              data-testid={`reply-${reply.id}`}
            >
              <div className="flex items-center gap-2 mb-2">
                <span 
                  className="text-sm font-medium"
                  style={{ color: reply.is_anonymous ? '#A9756B' : '#1A1A2E', fontFamily: 'Jost, sans-serif' }}
                >
                  {reply.author_name}
                </span>
                <span 
                  className="text-xs"
                  style={{ color: '#8A8798', fontFamily: 'Jost, sans-serif' }}
                >
                  {formatDate(reply.created_at)}
                </span>
              </div>
              <p 
                className="text-sm leading-relaxed"
                style={{ color: '#4A4A5A', fontFamily: 'Jost, sans-serif' }}
              >
                {reply.content}
              </p>
            </div>
          ))}
        </div>

        {/* Reply Form */}
        <div 
          className="p-4 rounded-xl"
          style={{ background: '#FAF7F3', border: '1px solid #F7F1EE' }}
        >
          <textarea
            value={replyContent}
            onChange={(e) => setReplyContent(e.target.value)}
            placeholder="Add to the discussion..."
            className="w-full p-3 rounded-lg resize-none focus:outline-none mb-3"
            style={{ 
              background: 'rgba(26,26,46,0.06)', 
              color: '#1A1A2E',
              border: '1px solid #F7F1EE',
              fontFamily: 'Jost, sans-serif',
              minHeight: '80px'
            }}
            data-testid="reply-content"
          />
          <div className="flex items-center justify-between">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={replyAnonymous}
                onChange={(e) => setReplyAnonymous(e.target.checked)}
                className="rounded"
                data-testid="reply-anonymous"
              />
              <span 
                className="text-sm"
                style={{ color: '#6B6878', fontFamily: 'Jost, sans-serif' }}
              >
                Reply anonymously
              </span>
            </label>
            <button
              onClick={onSubmitReply}
              disabled={submitting || replyContent.length < 10}
              className="px-4 py-2 rounded-full text-sm flex items-center gap-2 transition-all hover:scale-105 disabled:opacity-50"
              style={{ 
                background: '#C9A84C', 
                color: '#FBF9F6',
                fontFamily: 'Jost, sans-serif'
              }}
              data-testid="submit-reply"
            >
              <Send className="w-4 h-4" />
              {submitting ? 'Sending...' : 'Reply'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
